export default __webpack_public_path__ + "static/media/mallory_compact_light_italic.d1d4c464.ttf";